import React from "react";

export default function AlertEdit() {
  return (
    <div
      className="alert alert-success m-2 mb-0 d-none"
      id="editingModalSuccess"
      role="alert"
    >
      تم التعديل بنجاح
      <button
        type="button"
        className="close float-left"
        onClick={() => {
          document
            .getElementById("editingModalSuccess")
            .classList.add("d-none");
        }}
      >
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
  );
}
